import styled from 'styled-components';
import media from 'components/mixins/media';
import { transparentize } from 'utils/color';
import { Text, Link } from 'components/common';

export const LearnerAgreementText = styled(Text).attrs({
  'data-test': 'agreement-text'
})`
  && {
    font-size: 14px;
    text-align: center;
    font-weight: normal;
    line-height: 1.6;
    width: 320px;
    color: ${props =>
      transparentize(props.theme.colors.textColor, props.theme.themeUtils.getOpacity(true, 0.7))};
    ${media.mobile`
      width: 220px;
    `};
  }
`;

export const EulaLinkText = styled(Link).attrs({
  'data-test': 'eula-link-text'
})`
  font-size: 14px;
  text-align: center;
  font-weight: normal;
  margin-bottom: 36px;
  overflow-wrap: break-word;
  line-height: 1.6;
  width: 320px;
  color: ${props => props.theme.colors.ctaButtonColor};
  ${media.mobile`
    width: 220px;
  `};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
    color: ${props => props.theme.colors.ctaButtonColor};
  }
`;
